import { render, staticRenderFns } from "./CotizacionesRequerimientoComponent.vue?vue&type=template&id=327b3d76&scoped=true&"
import script from "./CotizacionesRequerimientoComponent.vue?vue&type=script&lang=js&"
export * from "./CotizacionesRequerimientoComponent.vue?vue&type=script&lang=js&"
import style0 from "./CotizacionesRequerimientoComponent.vue?vue&type=style&index=0&id=327b3d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327b3d76",
  null
  
)

export default component.exports